import { NgModule } from '@angular/core';
import { PriceModule } from '@icc/price';
import { PriceRollerService } from './price-roller.service';
import { PriceCassonettoService } from './price-cassonetto.service';

@NgModule({
    imports: [PriceModule],
    providers: [PriceRollerService, PriceCassonettoService],
})
export class ShutterPriceModule {}
